/**
 * Shared Highcharts ESM entry for Vite. Product modules must import from
 * `highcharts/esm/...` so they attach to this instance (UMD module paths break
 * under the 13.0.1 `module` field with SeriesRegistry errors).
 */
import Highcharts from 'highcharts/esm/highcharts.js';

export default Highcharts;
